import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_012.jpg';
page.images = [
  {
    imageId: 'page012_zoom0',
    rectangle: {
      x: 137,
      y: 345,
      width: 1638,
      height: 1732,
    },
    imageSrc: 'images/page012/012.jpg',
  },
];
page.paint = [
  {
    id: 'page006_game4',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Narysuj ikonę.  ',
      audio: 'files/page006/z6c4.mp3',
      item: {
        path: 'informatyka/files/page006/z.6cw.4.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  // {
  //   id: 'page006_game1',
  //   tooltip: '',
  //   icon: 'ikona_cw1',
  //   pos: {
  //     x: LEFT,
  //     y: 0,
  //   },
  // },
  {
    id: 'page006_game2',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page006_game3',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
export default page;
